export const statusKeys = {
  AVAILABLE: 'available',
  POSITIVE: 'positive',
  NEGATIVE: 'negative',
}
